import React, { useState } from 'react';
import { css } from 'emotion';
import mapsMock from '../img/maps.jpg';

function OptInMap() {
  const [loadMap, setLoadMap] = useState(false);

  if (loadMap) {
    return (
      <iframe
        src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJFRBFQVVVVQUR9kG_NiPdmss&key=AIzaSyCk_m-FbtVIR6fVENEIQKuJqszdWflGybY"
        className={style.googleMaps}
        title="Haardbeat"
      ></iframe>
    );
  } else {
    const hint =
      'Karte anzeigen\nBitte klicken Sie hier, um die interaktive Google Map anzuzeigen.\nDabei werden personenbezogene Daten wie Ihre IP-Adresse an Google in den USA übertragen.';
    return (
      <div className={style.optIn}>
        <div className={style.optInButton} onClick={() => setLoadMap(true)} title={hint}>
          <div className={style.optInTitle}>Karte anzeigen</div>
          <div className={style.optInHint}>
            Bitte klicken Sie hier, um die interaktive Google Map anzuzeigen. Dabei werden personenbezogene Daten wie Ihre IP-Adresse an Google in den USA
            übertragen.
          </div>
        </div>
      </div>
    );
  }
}

const style = {
  googleMaps: css`
    width: 100%;
    height: 100%;
    border: 0;
  `,
  optIn: css`
    background-color: lightgray;
    background-image: url(${mapsMock});
    background-size: cover;
    background-position: 50%;
    width: 100%;
    height: 100%;
    border: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  `,
  optInButton: css`
    background-color: #ffffff;
    border-radius: 4px;
    width: 75%;
    margin: auto;
    cursor: pointer;
    padding: 10px;
    opacity: 0.9;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
  `,
  optInTitle: css`
    text-align: center;
    font-size: 14px;
  `,
  optInHint: css`
    font-size: 12px;
  `,
};

export default OptInMap;
